import type { AxiosError, AxiosResponse } from "axios";
import type {
  AddTableFilterInput,
  ResourcePreference,
  SetPreferenceDataInput,
  TableFilterResponse,
  UpdateTableFilterInput,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const getResourcePreference = async (): Promise<ResourcePreference> => {
  try {
    const url = "controlCenter/preference/resource_web_app";
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};

export const setResourcePreference = async ({
  preferenceType,
  data,
}: SetPreferenceDataInput) => {
  try {
    const url = `controlCenter/preference/${preferenceType}/resource_web_app`;
    const response = await axiosClient.post(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const addTableFilter = async (data: AddTableFilterInput) => {
  try {
    const url = "v1/controlCenter/table/filters";
    const response = await axiosClient.post(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    return apiErrorHandler(error);
  }
};

export const updateTableFilter = async (data: UpdateTableFilterInput) => {
  try {
    const url = "v1/controlCenter/table/filters";
    const response = await axiosClient.patch(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    return apiErrorHandler(error);
  }
};

export const deleteTableFilter = async (filterId: string) => {
  try {
    const url = `v1/controlCenter/table/filters/${filterId}`;
    const response = await axiosClient.delete(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    return apiErrorHandler(error);
  }
};

export const getTableFilters = async (): Promise<TableFilterResponse[]> => {
  try {
    const url = "v1/controlCenter/table/filters";
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    return apiErrorHandler(error);
  }
};
